import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Toggle } from '@interfaces/Toggle';

@Injectable({ providedIn: 'root' })
export class ToggleApi {
  constructor(private http: HttpClient) {}

  getToggles() {
    return this.http.get<Toggle[]>(`/toggles`).toPromise();
  }
}
